import {Link} from "react-router-dom";
import Popup from "reactjs-popup";
import popupStyles from "../../utils/popupConfig";
import moment from "moment/moment";
import React from "react";

const LIVE_STATUS_LABEL = {
  "LIVE": "Live",
  "MODIFIED": "Modified",
  "NOT_LIVE": "Not Live",
}

const LIVE_STATUS_CLASS = {
  "LIVE": "is-live",
  "MODIFIED": "is-modified",
  "NOT_LIVE": ""

}

const DEFAULT_LIVE_STATUS_CLASS = "";

const DEFAULT_LIVE_STATUS_LABEL = "Not Live";
export const LogicListItem = ({
  logic,
  onChange,
  selected
}) => {

  const currentLiveStatusLabel = LIVE_STATUS_LABEL[logic.liveStatus]
      || DEFAULT_LIVE_STATUS_LABEL;

  const currentLiveStatusClass = LIVE_STATUS_CLASS[logic.liveStatus]
      || DEFAULT_LIVE_STATUS_CLASS;

  return (
      <div className="logic-wrapper">
        <input type="checkbox" className="checkbox"
               checked={selected}
               onChange={onChange}/>
        <Link to={`/logics/${logic.id}`}
              className="logic-card">
          <Popup
              contentStyle={popupStyles.contentStyle}
              arrowStyle={popupStyles.arrowStyle}
              trigger={
                <div className={"logic-status " + currentLiveStatusClass}>
                  <i className="material-icons">play_circle_filled</i>
                </div>
              }
              position="bottom center"
              on="hover">
            <span>{currentLiveStatusLabel}</span>
          </Popup>

          {logic.type === "COMPONENT" ? (
              <div className="info-box">
                <span className="logic-name">{logic.name }</span>
                <p className="component-info"> (COMPONENT)</p>
              </div>
          ) : (<span className="logic-name">{logic.name}</span>)}
          <span className="logic-date">{moment(
              logic.createdDate).calendar()}</span>
        </Link>
      </div>
  )
}
